var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 3.924a8.202 8.202 0 0 1-2.357.646 4.115 4.115 0 0 0 1.805-2.27 8.214 8.214 0 0 1-2.606.996A4.103 4.103 0 0 0 9.85 7.039 11.649 11.649 0 0 1 1.392 2.75a4.084 4.084 0 0 0-.555 2.063 4.1 4.1 0 0 0 1.825 3.415 4.087 4.087 0 0 1-1.858-.513v.052a4.106 4.106 0 0 0 3.29 4.023 4.108 4.108 0 0 1-1.852.07 4.107 4.107 0 0 0 3.833 2.85 8.232 8.232 0 0 1-5.096 1.756A8.55 8.55 0 0 1 0 16.409a11.614 11.614 0 0 0 6.29 1.843c7.547 0 11.675-6.252 11.675-11.674 0-.178-.005-.355-.012-.531A8.336 8.336 0 0 0 20 3.924Z","fill":"currentColor"}));
}

Twitter.defaultProps = {"fill":"none","viewBox":"0 0 20 20"};

module.exports = Twitter;

Twitter.default = Twitter;
